'use strict';

(function () {
  angular
    .module('specsguardApp')
    .directive('sgElementCommentItem', sgElementCommentItem);

  sgElementCommentItem.$inject = ['sgElementItems'];

  function sgElementCommentItem (sgElementItems) {
    return {
      templateUrl: 'app-legacy/components/sg-element-items/sg-element-comment-item.tmpl.html',
      transclude: true,
      scope: {
        item: '=',
        labels: '=',
        setFullName: '&'
      },
      link: function ($scope) {
        $scope.fullName = (item) => sgElementItems.setFullName(item);
      }
    };
  }
})();
